import { render, staticRenderFns } from "./ManageVeterinaryHospitalization.vue?vue&type=template&id=6db35046&scoped=true"
import script from "./ManageVeterinaryHospitalization.vue?vue&type=script&lang=js"
export * from "./ManageVeterinaryHospitalization.vue?vue&type=script&lang=js"
import style0 from "./ManageVeterinaryHospitalization.vue?vue&type=style&index=0&id=6db35046&prod&scoped=true&lang=css"
import style1 from "./ManageVeterinaryHospitalization.vue?vue&type=style&index=1&id=6db35046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db35046",
  null
  
)

export default component.exports